import { COLORS } from '~theme/colors'
import { typography } from '~theme/global'

const CELL_FONT_SIZE = '0.875rem'

export const MuiDataGrid = {
  styleOverrides: {
    root: {
      border: 'none',
      '--DataGrid-rowBorderColor': 'white !important',
      '& .MuiSvgIcon-root': {
        fill: COLORS.secondary.darkBlue,
      },
      '& .MuiCheckbox-root .MuiSvgIcon-root': {
        fill: 'currentColor',
      },
      '& .MuiAlert-root .MuiSvgIcon-root': {
        fill: 'currentColor',
      },
      '& .MuiDataGrid-main': {
        // Row gap removed - using margin on row instead for autoHeight compatibility
      },
      '& .MuiDataGrid-withBorderColor': {
        borderColor: 'transparent',
      },
      '& .MuiDataGrid-row--borderBottom .MuiDataGrid-columnHeader, & .MuiDataGrid-row--borderBottom .MuiDataGrid-filler, & .MuiDataGrid-row--borderBottom .MuiDataGrid-scrollbarFiller':
        {
          borderBottom: 'none',
        },
      '& .MuiDataGrid-filler': {
        backgroundColor: 'transparent',
        div: {
          border: 'none',
        },
      },
      '& .MuiDataGrid-filler--pinnedLeft, & .MuiDataGrid-filler--pinnedRight': {
        border: 'none',
        backgroundColor: 'transparent',
      },
    },
    columnHeaders: {
      backgroundColor: 'transparent',
      borderBottom: 'none',
    },
    columnHeader: {
      ...typography.label,
      color: COLORS.secondary.darkBlue,
      '&:focus, &:focus-within': {
        outline: 'none',
      },
    },
    columnHeaderTitle: {
      ...typography.label,
    },
    columnSeparator: {
      '& svg': {
        fill: 'white',
      },
      '&:hover, &.MuiDataGrid-columnSeparator--resizing': {
        visibility: 'visible',
      },
    },
    row: {
      backgroundColor: COLORS.greys.ultraLight,
      borderRadius: 0,
      transition: 'background-color 0.2s ease-in-out',
      '&:hover': {
        backgroundColor: COLORS.primary.white,
        outline: `3px solid ${COLORS.greys.greyTint}`,
        outlineOffset: '-3px',
        '& .MuiDataGrid-cell:first-of-type': {
          borderLeft: `2px solid ${COLORS.greys.greyTint}`,
        },
        '& .MuiDataGrid-cell:last-of-type': {
          borderRight: `2px solid ${COLORS.greys.greyTint}`,
        },
        '& .MuiDataGrid-cell--pinnedLeft, & .MuiDataGrid-cell--pinnedRight': {
          backgroundColor: COLORS.greys.ultraLight,
        },
        '& .MuiDataGrid-cell:has(+ .MuiDataGrid-cellEmpty)': {
          borderRight: `4px solid ${COLORS.primary.white}`,
        },
      },
      '&.Mui-selected': {
        backgroundColor: COLORS.greys.ultraLight,
        '&:hover': {
          backgroundColor: COLORS.primary.white,
        },
      },
      // Remove default striping since we want consistent background
      '&.even, &.odd': {
        backgroundColor: COLORS.greys.ultraLight,
        '&:hover': {
          backgroundColor: COLORS.primary.white,
        },
      },
    },
    cell: {
      ...typography.paragraph2,
      fontSize: CELL_FONT_SIZE,
      color: COLORS.secondary.darkBlue,
      border: 'none',
      borderTop: 'none',
      borderBottom: 'none',
      borderRight: `4px solid ${COLORS.primary.white}`,
      padding: '10px 12px',
      display: 'flex',
      alignItems: 'center',
      '&:focus, &:focus-within': {
        outline: 'none',
      },
      '&:last-of-type': {
        borderRight: 'none',
      },
      '&:has(+ .MuiDataGrid-cellEmpty)': {
        borderRight: `4px solid ${COLORS.greys.ultraLight}`,
      },
      '&.MuiDataGrid-cellEmpty': {
        padding: 0,
      },
      '&.MuiDataGrid-cell--editable': {
        cursor: 'pointer',
      },
      '&.MuiDataGrid-cell--editing': {
        position: 'relative',
        zIndex: 1,
      },
      '& .MuiTypography-root': {
        fontSize: CELL_FONT_SIZE,
      },
      '& .MuiSelect-select': {
        fontSize: CELL_FONT_SIZE,
      },
      '& a': {
        ...typography.link,
        fontSize: CELL_FONT_SIZE,
        cursor: 'pointer',
      },
    },
    cellCheckbox: {
      borderRight: `4px solid ${COLORS.primary.white}`,
    },
    footerContainer: {
      borderTop: 'none',
      '& .MuiTablePagination-root': {
        color: COLORS.secondary.darkBlue,
      },
      '& .MuiTablePagination-selectLabel, & .MuiTablePagination-displayedRows':
        {
          ...typography.h4,
          fontSize: '0.875rem',
          textTransform: 'uppercase',
        },
      '& .MuiTablePagination-select': {
        ...typography.h4,
        fontSize: '0.875rem',
      },
      '& .MuiTablePagination-actions': {
        '& .MuiIconButton-root': {
          border: `1px solid ${COLORS.greys.mid}`,
          borderRadius: '4px',
          marginLeft: '8px',
          '&:hover': {
            backgroundColor: COLORS.greys.ultraLight,
          },
          '&.Mui-disabled': {
            opacity: 0.3,
          },
        },
      },
    },
    toolbarContainer: {
      padding: '8px 0',
      backgroundColor: COLORS.primary.white,
    },
    overlay: {
      backgroundColor: 'transparent',
    },
  },
}
